import { getDateOnlyFormat } from './helpers';
import { Section } from '../views/StudyPlan/types';

export const formatDateRange = (startDate: string | Date, endDate: string | Date) => {
  if (startDate && endDate) {
    const formattedStart = getDateOnlyFormat(startDate, '/', true);
    const formattedEnd = getDateOnlyFormat(endDate, '/', true);
    return `${formattedStart} - ${formattedEnd}`;
  }
  return '-';
};

export const formatSchedule = (section: Section | null | undefined) => {
  if (!section?.sectionTimeSlots || section.sectionTimeSlots.length === 0) {
    return '-';
  }

  return section.sectionTimeSlots.map((sts) => {
    const { timeSlot } = sts;
    let startTime = '';
    let endTime = '';
    if (timeSlot.startTime) {
      startTime = typeof timeSlot.startTime === 'string'
        ? timeSlot.startTime.slice(0, 5)
        : String(timeSlot.startTime);
    }
    if (timeSlot.endTime) {
      endTime = typeof timeSlot.endTime === 'string'
        ? timeSlot.endTime.slice(0, 5)
        : String(timeSlot.endTime);
    }
    const weekDay = timeSlot.weekDay || '';
    return weekDay ? `${weekDay} ${startTime} hrs - ${endTime} hrs` : `${startTime} hrs - ${endTime} hrs`;
  }).join(', ');
};

export const formatSectionLocation = (section: Section | null | undefined) => {
  if (!section) {
    return '-';
  }
  const locationName = section.location?.name || '';
  const miPreuId = section.mipreuId || '';

  if (locationName && miPreuId) {
    return `${locationName} - ${miPreuId}`;
  }
  if (locationName) {
    return locationName;
  }
  if (miPreuId) {
    return miPreuId;
  }
  return '-';
};

/**
 * Formatea una fecha como "dd/mm/aaaa a las hh:mm" (hora local).
 * Devuelve null si la fecha no es válida, para poder omitir el mensaje que la contiene.
 */
export const formatDateTimeLong = (date: string | Date | null | undefined) => {
  if (!date) {
    return null;
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  const hours = String(parsed.getHours()).padStart(2, '0');
  const minutes = String(parsed.getMinutes()).padStart(2, '0');

  return `${getDateOnlyFormat(parsed, '/', true)} a las ${hours}:${minutes}`;
};
